import { render, staticRenderFns } from "./noti.vue?vue&type=template&id=11bde8e9&"
import script from "./noti.vue?vue&type=script&lang=js&"
export * from "./noti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports